import React from 'react'
import PropTypes from 'prop-types'
import { HeroMain } from './index.style'
import { Heading1 } from '@components/TextStyles'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import Border from '@components/Border'
import { colors } from '@styles/vars/colors.style'
import AnimateSlideIn from '@components/animation/AnimateSlideIn'
// import { GatsbyImage } from 'gatsby-plugin-image'

const Hero = ({ data }) => {
  return (
    <HeroMain>
      <Spacer size={[65, 80]} />

      <Container>
        {/* {data.imageA && (
          <HeroImageA>
            <GatsbyImage image={data.imageA.gatsbyImageData} alt="" />
          </HeroImageA>
        )} */}

        <Spacer size={[105, 140]} />

        <AnimateSlideIn>
          <Heading1 secondary uppercase>
            {data.title}
          </Heading1>
        </AnimateSlideIn>

        <Spacer size={[60, 140]} />

        {/* {data.imageB && (
          <HeroImageB>
            <GatsbyImage image={data.imageB.gatsbyImageData} alt="" />
          </HeroImageB>
        )} */}
      </Container>

      <Border align="bottom" color={colors.yellow} />
    </HeroMain>
  )
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
